<template>
  <div>
    <vs-col>
      <!-- Sales Data Listing -->
      <div class="vx-card p-6">
        <vs-table
          class="vs-con-loading__container"
          id="sale__data"
          stripe
          :sst="true"
          maxHeight="500px"
          @search="updateSearchQuery"
          @change-page="handleChangePage"
          @sort="handleSort"
          search
          :data="sales"
        >
          <template slot="header">
            <div class="flex flex-wrap justify-between items-center">
              <div class="mb-4 md:mb-0 mr-4 ag-grid-table-actions-left">
                <vs-dropdown vs-trigger-click class="cursor-pointer">
                  <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                    <span class="mr-2">
                      {{ page * length - (length - (FilteredCount && 1)) }}
                      -
                      {{ FilteredCount - page * length > 0 ? page * length : FilteredCount }}
                      of {{ FilteredCount }} (filtered from {{ total }} total entries)
                    </span>
                    <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                  </div>
                  <vs-dropdown-menu>
                    <vs-dropdown-item @click="handleChangeLength(10)">
                      <span>10</span>
                    </vs-dropdown-item>
                    <vs-dropdown-item @click="handleChangeLength(20)">
                      <span>20</span>
                    </vs-dropdown-item>
                    <vs-dropdown-item @click="handleChangeLength(50)">
                      <span>50</span>
                    </vs-dropdown-item>
                    <vs-dropdown-item @click="handleChangeLength(100)">
                      <span>100</span>
                    </vs-dropdown-item>
                  </vs-dropdown-menu>
                </vs-dropdown>
              </div>
              <div class="mb-4 md:mb-0 mr-4 ag-grid-table-actions-left">
                <vs-row vs-justify="flex-end">
                  <vx-tooltip text="Export CSV">
                    <vs-button class="mr-1" type="filled" color="primary" icon-pack="feather" @click="exportExcel" icon="icon-download" />
                  </vx-tooltip>
                </vs-row>
              </div>
            </div>
          </template>

          <template slot="thead">
            <vs-th sort-key="sales.id">Sr#</vs-th>
            <vs-th sort-key="sales.sales_date">Sales Date</vs-th>
            <vs-th sort-key="sales.sales_code">Sales Code</vs-th>
            <vs-th>Sales Status</vs-th>
            <vs-th>Reference No.</vs-th>
            <vs-th sort-key="customer.business_name">Customer Name</vs-th>
            <vs-th sort-key="sales.grand_total">Total</vs-th>
            <vs-th sort-key="sales.paid_amount">Paid Payment</vs-th>
            <vs-th sort-key="sales.payment_status">Payment Status</vs-th>
            <vs-th sort-key="user.username">Created by</vs-th>
            <vs-th>Action</vs-th>
          </template>

          <template slot-scope="{ data }" ref="tableBody">
            <vs-tr :key="i" v-for="(tr, i) in data">
              <vs-td>
                {{ page * length - (length - i - 1) }}
              </vs-td>
              <vs-td>
                {{ formatDate(tr.sales_date) }}
              </vs-td>
              <vs-td>
                {{ tr.sales_code }}
              </vs-td>
              <vs-td>
                <vs-chip :color="tr.return_type === 'partial' ? 'warning' : tr.return_type === 'voided' ? 'danger' : 'primary'">
                  {{ tr.return_type === 'partial' ? 'Partial Return' : tr.return_type.charAt(0).toUpperCase() + tr.return_type.slice(1) }}
                </vs-chip>
              </vs-td>
              <vs-td> - </vs-td>
              <vs-td>
                {{ tr.customer.business_name }}
              </vs-td>
              <vs-td> $ {{ tr | grandTotal }} </vs-td>
              <vs-td> $ {{ tr | paidAmount }} </vs-td>
              <vs-td>
                <vs-chip :color="paymentBadgeColor(tr)">{{ paymentChipText(tr) }}</vs-chip>
              </vs-td>
              <vs-td>
                {{ tr.user.username }}
              </vs-td>
              <vs-td>
                <vs-dropdown vs-trigger-click class="cursor-pointer">
                  <div class="p-4 border border-solid d-theme-border-grey-light cursor-pointer flex items-center justify-between font-medium">
                    Actions
                    <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                  </div>
                  <vs-dropdown-menu class="invoice__actions">
                    <vs-dropdown-item @click="viewInvoice(tr.id)"> <feather-icon icon="EyeIcon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" /> Sales Return</vs-dropdown-item>
                    <vs-dropdown-item @click="viewPaymentsHistory(tr.id)" v-if="checkPermissionByIds([permissions.SALE_PALYMENT_VIEW])">
                      <feather-icon icon="DollarSignIcon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" /> View Payments
                    </vs-dropdown-item>
                    <vs-dropdown-item @click="payNow(tr)"> <feather-icon icon="CreditCardIcon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" /> Pay Now </vs-dropdown-item>
                    <vs-dropdown-item @click="setPdfInvoice(tr)" v-if="tr.return_type !== 'voided'">
                      <feather-icon icon="FilePlusIcon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" /> PDF Invoice
                    </vs-dropdown-item>
                    <vs-dropdown-item @click="setPdfReturnInvoice(tr)" v-if="tr.sales_return">
                      <feather-icon icon="TruckIcon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" /> PDF Return Invoice
                    </vs-dropdown-item>
                    <vs-dropdown-item @click="setShippingMenifest(tr)">
                      <feather-icon icon="ShoppingCartIcon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" /> Shipping Manifest
                    </vs-dropdown-item>
                    <vs-dropdown-item @click="setPdfShippingMenifest(tr)">
                      <feather-icon icon="FileTextIcon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" /> PDF Shipping Manifest
                    </vs-dropdown-item>
                    <vs-dropdown-item v-if="checkPermissionByIds([permissions.SALE_DELETE])" @click="deleteRecord(tr)">
                      <feather-icon icon="Trash2Icon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" /> Delete
                    </vs-dropdown-item>
                    <vs-dropdown-item @click="viewPosInvoice(tr.id)"> <feather-icon icon="LayersIcon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" /> POS Invoice </vs-dropdown-item>
                  </vs-dropdown-menu>
                </vs-dropdown>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>

        <vs-pagination v-model="page" :total="totalPages" :max="totalPages / length > 7 ? 7 : 9" class="mt-8"></vs-pagination>
      </div>
      <!-- End Sales Data Listing -->

      <!-- Pay Now Dialogue -->
      <vs-popup id="pay-now-popup" class="vs-con-loading__container text-center" title="Payments" button-accept="false" button-cancel="false" :active.sync="paymentsPayNow">
        <vs-table stripe :sst="true" maxHeight="500px" :data="data">
          <template slot="thead">
            <vs-th>Name</vs-th>
            <vs-th>Mobile</vs-th>
            <vs-th>Email</vs-th>
            <vs-th>Invoice</vs-th>
            <vs-th>Sales Date</vs-th>
            <vs-th>Paid Amount</vs-th>
            <vs-th>Due Amount</vs-th>
            <vs-th>Grand Total</vs-th>
          </template>

          <template ref="tableBody">
            <vs-tr class="text-left">
              <vs-td>{{ salesPayInfo.customer && salesPayInfo.customer.business_name }}</vs-td>
              <vs-td>{{ salesPayInfo.customer && salesPayInfo.customer.phone }}</vs-td>
              <vs-td>{{ salesPayInfo.customer && salesPayInfo.customer.email }}</vs-td>
              <vs-td>{{ salesPayInfo.sales_code }}</vs-td>
              <vs-td>{{ formatDate(salesPayInfo.sales_date) }}</vs-td>
              <vs-td>$ {{ salesPayInfo.paid_amount | currencyFilter }}</vs-td>
              <vs-td>$ {{ calculate_due_amount_pay_now | currencyFilter }}</vs-td>
              <vs-td>$ {{ calculate_grand_total_pay_now | currencyFilter }}</vs-td>
            </vs-tr>
          </template>
        </vs-table>
        <!-- <div class="grid grid-cols-3">
          <vs-col class="vx-col w:4/1 text-left">
            <p>Customer Information</p>
            <p class="font-extrabold">Baker Retail</p>
            <p>Mobile: 51515555555</p>
            <p>Email: bryon@bakerretail.com</p>
          </vs-col>
          <div class="vx-col w:4/1 text-center">
            <p>Sales Information:</p>
            <p>Invoice #SL46543</p>
            <p class="font-extrabold">Date:12/08/2020</p>
            <p><span class="font-extrabold">Grand Total</span> :-0.25</p>
          </div>
          <div class="vx-col w:4/1 text-left">
            <p><span class="font-extrabold"> Paid Amount</span> :-0.25</p>
            <p><span class="font-extrabold"> Due Amount </span>:0.00:</p>
          </div>
        </div> -->
        <div class="vx-row px-5 pt-5">
          <div class="vx-col md:w-1/3 px-8">
            <div class="vx-row mb-2">
              <vs-input disabled icon="icon icon-list" :value="moment().format('l')" icon-pack="feather" class="w-full" label="Date" name="Date" v-validate="'required'" />
            </div>
          </div>
          <div class="vx-col md:w-1/3 px-8">
            <div class="vx-row mb-2">
              <vs-input icon="icon icon-list" :value="amount" @input="(int) => (amount = int)" icon-pack="feather" class="w-full" label="Amount" name="Amount" v-validate="'required|min_value:0.01'" />
              <span class="text-danger text-sm" v-show="errors.has('Amount')">{{ errors.first('Amount') }}</span>
            </div>
          </div>
          <div class="vx-col md:w-1/3 px-8">
            <div class="vx-row mb-2">
              <label for="">Payment Type</label>
              <select-2
                autocomplete
                class="w-full"
                id="payment_type"
                :value="payment_type"
                @input="(item) => (payment_type = item && item.value)"
                placeholder="Please Select Payment Type"
                :options="paymentTypes"
                name="Payment Type"
                v-validate="'required'"
              />
              <span class="text-danger text-sm" v-show="errors.has('Payment Type')">{{ errors.first('Payment Type') }}</span>
            </div>
          </div>
          <div class="vx-col md:w-full px-8 mt-5">
            <div class="vx-row mb-2">
              <vs-textarea label="Payment Note" :value="payment_note" @input="(string) => (payment_note = string)" height="60px" />
            </div>
          </div>
        </div>
        <hr style="background: lightgrey" />
        <div class="vx-row mt-3">
          <div class="vx-col w-full">
            <div class="float-right">
              <vs-button class="mr-2" v-if="checkPermissionByIds([permissions.SALE_PALYMENT_ADD])" @click="payPayment" :disabled="!validateForm" type="relief">Save Changes</vs-button>
              <vs-button to="/pos/invoice-list" color="danger" @click="paymentsPayNow = false" type="relief" class="text-left">Cancel</vs-button>
            </div>
          </div>
        </div>
      </vs-popup>
      <!-- End Pay Now Dialogue -->

      <!-- View Payment Dialogue -->
      <vs-popup id="view-payment" class="vs-con-loading__container text-center" title="View Payments" button-accept="false" button-cancel="false" :active.sync="ViewAllPayment">
        <vs-table stripe :sst="true" maxHeight="500px" :data="data">
          <template slot="thead">
            <vs-th>Name</vs-th>
            <vs-th>Invoice</vs-th>
            <vs-th>Sales Date</vs-th>
            <vs-th>Grand Total</vs-th>
            <vs-th>Paid Amount</vs-th>
            <vs-th>Due Amount</vs-th>
          </template>

          <template>
            <vs-tr class="text-left">
              <vs-td>{{ paymentHistory.customer && paymentHistory.customer.business_name }}</vs-td>
              <vs-td>{{ paymentHistory.sales_code }}</vs-td>
              <vs-td>{{ formatDate(paymentHistory.sales_date) }}</vs-td>
              <vs-td>$ {{ calculate_grand_total_payment_history | currencyFilter }}</vs-td>
              <vs-td>$ {{ paymentHistory.paid_amount | currencyFilter }}</vs-td>
              <vs-td>$ {{ calculate_due_amount_payment_history | currencyFilter }}</vs-td>
            </vs-tr>
          </template>
        </vs-table>
        <hr />
        <h6 class="mt-2 mb-2">Payment History</h6>
        <hr />
        <vs-table :data="salesPayments">
          <template slot="thead">
            <vs-th>Payment Date </vs-th>
            <vs-th>Payment</vs-th>
            <vs-th>Payment Type </vs-th>
            <vs-th>Payment Note </vs-th>
            <vs-th>Created by </vs-th>
            <vs-th>Action</vs-th>
          </template>

          <template slot-scope="{ data }">
            <vs-tr class="text-left" :data="tr" :key="i" v-for="(tr, i) in data">
              <vs-td>{{ formatDate(tr.payment_date) }}</vs-td>
              <vs-td>$ {{ tr.payment_amount | currencyFilter }}</vs-td>
              <vs-td>{{ tr.payment_type }}</vs-td>
              <vs-td>{{ tr.payment_note }}</vs-td>
              <vs-td>{{ tr.payment_type }}</vs-td>
              <vs-td>
                <div v-if="checkPermissionByIds([permissions.SALE_PALYMENT_DELETE])">
                  <feather-icon
                    v-if="checkPermissionByIds([permissions.SALE_PALYMENT_DELETE])"
                    icon="Trash2Icon"
                    svgClasses="h-5 w-5 hover:text-danger cursor-pointer"
                    @click="deletePayemntHistory(tr.id)"
                  />
                </div>
                <div v-else>-</div>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
        <hr style="background: lightgrey" />
        <div class="vx-row mt-3">
          <div class="vx-col w-full">
            <div class="float-right">
              <vs-button to="/pos/invoice-list" color="danger" @click="ViewAllPayment = false" type="relief" class="text-left">Close</vs-button>
            </div>
          </div>
        </div>
      </vs-popup>
      <!-- End View Payment Dialogue -->
    </vs-col>

    <!-- pdf container -->
    <div id="pdf-container"></div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import XLSX from 'xlsx'
import moment from 'moment'
import axios from '@/axios'
import Vue from 'vue'
import { dateMixins } from '@/mixins/dateMixins.js'
import PdfInvoice from '@/views/pos/pdf/PdfInvoice.vue'
import PdfReturnInvoice from '@/views/pos/pdf/PdfReturnInvoice.vue'
import { paymentTypes, paymentMixins } from '@/utils/paymentTypes'
import Select2 from '@/components/custom/form-elements/Select2.vue'

export default {
  name: 'PosInvoiceList',

  components: {
    Select2
  },

  data: () => ({
    saleId: null,

    order: [],
    length: 10,
    page: 1,
    search: '',
    paymentsPayNow: false,
    amount: 0,
    id: 0,
    payment_note: '',
    payment_type: '',
    ViewAllPayment: false,
    processing: false,
    generating: false,
    salesPayInfo: {},
    paymentHistory: {},
    data: [{}],
    paymentTypes
  }),

  mixins: [paymentMixins, dateMixins],

  // mounted
  async mounted() {
    this.totalInoviceData()
    this.getData()
  },

  // computed
  computed: {
    ...mapState('pos', ['sales', 'sale', 'total', 'loading', 'FilteredCount', 'sale-list-dashboard']),
    ...mapState('permission', ['permissions']),
    ...mapGetters('auth', ['checkPermissionByIds']),

    // set total pages for pagination
    totalPages() {
      return Math.ceil(this.FilteredCount / this.length)
    },

    // for payment history
    calculate_due_amount_payment_history() {
      if (this.calculate_grand_total_payment_history - this.paymentHistory.paid_amount > 0) {
        return this.calculate_grand_total_payment_history - this.paymentHistory.paid_amount
      }

      return 0
    },

    // for payment history
    calculate_grand_total_payment_history() {
      if (this.paymentHistory.grand_total - this.paymentHistory.paid_amount > 0) {
        if (this.paymentHistory.sales_return) {
          return this.paymentHistory.grand_total - this.paymentHistory.sales_return.grand_total
        }
      }

      return this.paymentHistory.grand_total
    },

    // for pay now popup
    calculate_due_amount_pay_now() {
      if (this.calculate_grand_total_pay_now - this.salesPayInfo.paid_amount > 0) {
        return this.calculate_grand_total_pay_now - this.salesPayInfo.paid_amount
      }

      return 0
    },

    // for pay now popup
    calculate_grand_total_pay_now() {
      if (this.salesPayInfo.grand_total - this.salesPayInfo.paid_amount > 0) {
        if (this.salesPayInfo.sales_return) {
          return this.salesPayInfo.grand_total - this.salesPayInfo.sales_return.grand_total
        }
      }

      return this.salesPayInfo.grand_total
    },

    salesPayments() {
      return this.paymentHistory.salesPayments || []
    },

    validateForm() {
      return !this.errors.any()
    }
  },

  // methods
  methods: {
    console() {
      return window.console
    },
    ...mapActions('pos', {
      getSalesData: 'getSalesData',
      paymentRecordDelete: 'paymentRecordDelete',
      updatePayments: 'payPaymentById',
      totalInoviceData: 'totalInoviceData',
      getSaleById: 'getSaleById',
      deleteSaleRecord: 'deleteSaleRecord'
    }),
    moment,
    handleChangeLength(length) {
      this.page = 1
      this.length = length
      this.getData()
    },
    handleChangePage(page) {
      this.page = page
      this.getData()
    },
    handleSort(key, active) {
      if (!key) return
      this.page = 1
      this.order = [key, active === 'desc' ? 'DESC' : 'ASC']
      this.getData()
    },
    updateSearchQuery(val) {
      this.page = 1
      this.search = val
      this.getData()
    },
    getData() {
      const { page, length, order, search } = this

      this.generating = true
      this.getSalesData({
        page,
        limit: length,
        order,
        search
      }).finally(async () => {
        this.generating = false
        await this.totalInoviceData()
      })
    },
    async deleteRecord(tr) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirm Delete',
        text: 'Are you sure, you want to delete this record?',
        accept: () => this.deleteSale(tr.id),
        acceptText: 'Delete'
      })
    },
    async deleteSale(id) {
      try {
        this.processing = true
        const { message } = await this.deleteSaleRecord({
          id
        })
        this.processing = false
        this.$vs.notify({
          title: 'Success',
          text: message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'success'
        })
        this.getData()
      } catch ({ message }) {
        this.processing = false
        this.$vs.notify({
          title: 'Error',
          text: message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
      }
    },
    async setPdfInvoice(tr) {
      this.generating = true
      await this.getSaleById(tr.id)
      const ap = document.querySelector('#mount-node')
      if (ap) {
        ap.remove()
      }
      const elem = document.querySelector('#pdf-container')
      const mountNode = document.createElement('div')
      mountNode.id = 'mount-node'
      elem.appendChild(mountNode)

      const pdfInvoice = Vue.extend(PdfInvoice)

      new pdfInvoice({
        store: this.$store,
        propsData: {
          sale: this.sale
        }
      })
        .$on('downloaded', () => {
          this.generating = false
        })
        .$mount('#mount-node')
    },
    async setPdfReturnInvoice(tr) {
      this.generating = true
      await this.getSaleById(tr.id)
      const ap = document.querySelector('#mount-node')
      if (ap) {
        ap.remove()
      }
      const elem = document.querySelector('#pdf-container')
      const mountNode = document.createElement('div')
      mountNode.id = 'mount-node'
      elem.appendChild(mountNode)

      const pdfReturnInvoice = Vue.extend(PdfReturnInvoice)

      new pdfReturnInvoice({
        store: this.$store,
        propsData: {
          sale: this.sale
        }
      })
        .$on('downloaded', () => {
          this.generating = false
        })
        .$mount('#mount-node')
    },
    async setPdfShippingMenifest(tr) {
      this.saleId = tr.id
      const {
        data: { sales }
      } = await this.getSaleById(tr.id)
      try {
        this.generating = true
        const { data } = await axios({
          url: process.env.VUE_APP_PDF_SHIPPING_MENIFEST_URI,
          method: 'POST',
          responseType: 'blob',
          data: JSON.stringify(sales)
        })
        const url = window.URL.createObjectURL(data)
        const a = document.createElement('a')
        a.href = url
        a.download = 'shipping_manifest_not_editable.pdf'
        a.click()
        a.remove()
        setTimeout(() => window.URL.revokeObjectURL(url), 100)
        this.generating = false
      } catch (err) {
        this.generating = false
      }
    },
    async setShippingMenifest(tr) {
      this.saleId = tr.id
      const {
        data: { sales }
      } = await this.getSaleById(tr.id)
      try {
        this.generating = true
        const { data } = await axios({
          url: process.env.VUE_APP_SHIPPING_MENIFEST_URI,
          method: 'POST',
          responseType: 'blob',
          data: JSON.stringify(sales)
        })
        const url = window.URL.createObjectURL(data)
        const a = document.createElement('a')
        a.href = url
        a.download = 'shipping_manifest.pdf'
        a.click()
        a.remove()
        setTimeout(() => window.URL.revokeObjectURL(url), 100)
        this.generating = false
      } catch (err) {
        this.generating = false
      }
    },
    async viewPaymentsHistory(id) {
      this.ViewAllPayment = true
      const sales = await this.getSaleById(id)
      this.paymentHistory = sales.data.sales
    },
    deletePayemntHistory(id) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirm Delete',
        text: 'Are you sure, you want to delete this record?',
        accept: async () => {
          try {
            const { message } = await this.paymentRecordDelete(id)
            if (this.sales.length === 1 && this.page !== 1) {
              this.page -= 1
            }
            this.getData()
            this.processing = false
            this.ViewAllPayment = false
            this.$vs.notify({
              title: 'Success',
              text: message,
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'success'
            })
          } catch ({ message }) {
            this.processing = false
            this.$vs.notify({
              title: 'Error',
              text: message,
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger'
            })
          }
        },
        acceptText: 'Delete'
      })
    },

    paymentBadgeColor(sale) {
      if (sale.return_type === 'voided') {
        return 'danger'
      }

      return {
        paid: 'primary',
        unpaid: 'danger',
        partial: 'warning'
      }[sale.payment_status]
    },

    paymentChipText(sale) {
      if (sale.return_type === 'voided') {
        return 'Voided'
      }

      return `${sale.payment_status.charAt(0).toUpperCase()}${sale.payment_status.slice(1)}`
    },

    viewInvoice(id) {
      this.$router.push(`/pos/${id}/view-sales-invoice`)
    },

    payNow(tr) {
      this.salesPayInfo = tr
      this.paymentsPayNow = true
      this.id = tr.id
    },

    async payPayment() {
      if (!(await this.$validator.validate())) {
        return false
      }

      try {
        this.processing = true
        const { message } = await this.updatePayments({
          id: this.id,
          data: {
            amount: this.amount,
            payment_type: this.payment_type,
            payment_note: this.payment_note
          }
        })
        this.processing = false
        this.paymentsPayNow = false
        this.$vs.notify({
          title: 'Success',
          text: message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'success'
        })
        this.getData()
      } catch ({ message }) {
        this.processing = false
        this.$vs.notify({
          title: 'Error',
          text: message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
      }
    },

    exportExcel() {
      const wb = XLSX.utils.book_new()
      const ws = XLSX.utils.json_to_sheet(
        this.sales.map((sales) => ({
          'Sales Date': sales.sales_date,
          'Sales Code': sales.sales_code,
          'Sales Status': 'Final',
          'Customer Name': sales.customer ? sales.customer.business_name : '',
          Total: sales.sub_total,
          'Paid Payment': sales.paid_amount,
          'Payment Status': sales.payment_status,
          'Created by': sales.user.username
        }))
      )
      XLSX.utils.book_append_sheet(wb, ws, 'Sheet 1')
      XLSX.writeFile(wb, 'Sales Invoice.xlsx')
    },
    viewPosInvoice(saleId) {
      const routeData = this.$router.resolve({
        name: 'sale-invoice-print',
        params: {
          saleId
        }
      })
      window.open(routeData.href, '_blank', '"scrollbars=1,resizable=1,height=600,width=600"')
    }
  },

  filters: {
    grandTotal(sale) {
      let grand_total = sale.grand_total
      let totalRedeemDollar = sale.salesItems.reduce((acc, item) => acc + item.redeem_dollar, 0)

      if (sale.sales_return) {
        const returnRedeemDollar = sale.sales_return.salesItemsReturn.reduce((acc, item) => acc + item.return_redeem_dollar, 0)
        const returnGrandTotal = grand_total >= sale.sales_return.grand_total ? sale.sales_return.grand_total : grand_total
        grand_total = grand_total - (returnGrandTotal + returnRedeemDollar)
        totalRedeemDollar -= returnRedeemDollar
      }

      const tempGrandTotal = Math.max(0, grand_total - totalRedeemDollar)
      return paymentMixins.methods.mathRound(tempGrandTotal, 2)
    },

    paidAmount(sale) {
      let grand_total = sale.grand_total

      let totalRedeemDollar = sale.salesItems.reduce((acc, item) => acc + item.redeem_dollar, 0)

      if (sale.sales_return) {
        const returnRedeemDollar = sale.sales_return.salesItemsReturn.reduce((acc, item) => acc + item.return_redeem_dollar, 0)
        const returnGrandTotal = grand_total >= sale.sales_return.grand_total ? sale.sales_return.grand_total : grand_total

        grand_total = grand_total - (returnGrandTotal + returnRedeemDollar)
        totalRedeemDollar -= returnRedeemDollar
      }

      const tempGrandTotal = Math.max(0, grand_total - totalRedeemDollar)
      const tempPaidAmount = tempGrandTotal >= sale.paid_amount ? sale.paid_amount : tempGrandTotal

      return paymentMixins.methods.mathRound(tempPaidAmount, 2)
    },

    // currencyFilter rounded to 2 point
    currencyFilter(value) {
      return paymentMixins.methods.mathRound(Number(value), 2)
    }
  },

  // watch
  watch: {
    processing() {
      if (this.processing) {
        this.$vs.loading({
          container: '#pay-now-popup',
          scale: 0.45
        })
      } else {
        this.$vs.loading.close('#pay-now-popup > .con-vs-loading')
      }
    },
    generating() {
      if (this.generating) {
        this.$vs.loading({
          container: '#sale__data',
          scale: 0.45
        })
      } else {
        this.$vs.loading.close('#sale__data > .con-vs-loading')
      }
    },
    page() {
      this.getData()
    }
  },

  beforeRouteLeave(_, __, next) {
    this.paymentsPayNow = false
    this.ViewAllPayment = false
    next()
  }
}
</script>

<style lang="scss">
#pay-now-popup {
  .vs-popup {
    width: 860px !important;
  }
  .vs-popup--header {
    background: #bfc6b9;
    border-radius: 0;
  }
}
#view-payment {
  .vs-popup {
    width: 860px !important;
  }
  .vs-popup--header {
    background: #bfc6b9;
    border-radius: 0;
  }
}

.con-vs-dialog {
  z-index: 530000;
}

.invoice__actions {
  width: 220px;

  li {
    padding: 5px;
    a {
      display: flex !important;
      align-items: center;
    }
  }
}
</style>
